<template>
  <div>
    <Breadcrumb :items="breadcrumbItems" />
    
    <IpuForm
      @save="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import IpuForm from "../../../components/forms/IpuForm.vue";
import { IpuService } from "../../../services/IpuService";

export default {
  name: "CriarIpu",
  components: {
    Breadcrumb,
    IpuForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Página Inicial",
          disabled: false,
          href: "/"
        },
        {
          text: "Gerenciamento de IPUs",
          disabled: false,
          href: "/gerenciar-ipus"
        },
        {
          text: "Cadastro de IPU",
          disabled: true,
          href: "/ipus/criar"
        }
      ]
    };
  },
  methods: {
    async handleSave(formData) {
      try {
        // Criar FormData seguindo o padrão existente
        const postData = new FormData();
        
        postData.append("exercicio", formData.exercicio);
        postData.append("codigo_ipu", formData.codigo_ipu);
        postData.append("descricao", formData.descricao);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const response = await IpuService.store(postData);
        
        if (response) {
          // Redirecionar para a lista de IPUs após salvar
          this.$router.push('/gerenciar-ipus');
        } else {
          throw new Error('Erro ao criar IPU');
        }
      } catch (error) {
        console.error('Erro ao criar IPU:', error);
        // O componente IpuForm já trata a exibição de mensagens de erro
        throw error;
      }
    },
    handleCancel() {
      // Retornar para a tela principal do menu
      this.$router.push('/gerenciar-ipus');
    }
  }
};
</script>

<style scoped>
/* Estilos específicos da página, se necessário */
</style>